<template>
  <router-btn :text="$t('servicesystem.common_objects.commonterms.save')" :icon="'mdi-content-save'" :color="'primary'"
    :disabled="disabled" :outlined="false" :textbtn="textbtn" :large="large" :small="small" :loading="saving"
    @Press="action">
  </router-btn>
</template>


<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "SaveEmailTemplateBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  methods: {
    action() {
      this.$store.dispatch("EmailTemplatesStore/requestSave");
    },
  },

  computed: {
    saving() {
      return this.$store.getters["EmailTemplatesStore/saving"];
    },
    disabled() {
      const valid = this.$store.getters["EmailTemplatesStore/formValid"];
      const dirty = this.$store.getters["EmailTemplatesStore/isDirty"];
      return !valid || !dirty || this.saving;
    },
  },
};
</script>


<style lang="scss" scoped></style>
